import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslatePipe} from '@brunata-angular/util';
import {Router} from '@angular/router';
import {environment} from 'src/environments/environment';
import {LoadComponent} from '@brunata-angular/ui';
import {BrunataOnlineLogoComponentComponent} from '@shared/brunata-online-logo-component/brunata-online-logo-component.component';
import {loadUser} from 'src/app/state/actions';
import {Store} from '@ngrx/store';
import {selectUser} from 'src/app/state/selectors';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NgbAccordionModule} from '@ng-bootstrap/ng-bootstrap';
import {CookieService} from 'ngx-cookie-service';

@Component({
    selector: 'app-welcome',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        NgbAccordionModule,
        TranslatePipe,
        LoadComponent,
        BrunataOnlineLogoComponentComponent,
    ],
    templateUrl: './welcome.component.html',
    styleUrl: './welcome.component.scss',
})
export class WelcomeComponent {
    private readonly router = inject(Router);
    private readonly store = inject(Store);
    private readonly cookieService = inject(CookieService);
    protected readonly user$ = this.store.select(selectUser);

    constructor() {
        if (this.cookieService.check('access_token')) {
            this.store.dispatch(loadUser());
        }
        this.user$.pipe(takeUntilDestroyed()).subscribe(userState => {
            if (userState.status !== 'success') {
                return;
            }
            switch (userState.user.userType) {
                case 'CUSTOMER':
                case 'SUBUSER':
                    void this.router.navigate(['/admin']);
                    break;
                case 'CONSUMER':
                    window.location.replace('/mybrunata');
                    return;
            }
        });
    }

    login(): void {
        this.store.dispatch(loadUser());
    }

    newUser(): void {
        window.location.href = `${environment.reactOnlineUrl}/new-user`;
    }
}
